if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.currentIndex = 0;
        this.isZoomed = false;
        this.touchStartX = 0;
        this.touchEndX = 0;

        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);
      }

      connectedCallback() {
        if (super.connectedCallback) {
          super.connectedCallback();
        }

        this.createControls();

        this.addEventListener('click', this.handleClick);
        this.addEventListener('touchstart', this.handleTouchStart, {
          passive: true,
        });
        this.addEventListener('touchend', this.handleTouchEnd, {
          passive: true,
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('touchstart', this.handleTouchStart);
        this.removeEventListener('touchend', this.handleTouchEnd);
        document.removeEventListener('keydown', this.handleKeydown);
      }

      show(opener) {
        super.show(opener);

        document.body.classList.add('carami-product-modal-open');
        document.addEventListener('keydown', this.handleKeydown);

        requestAnimationFrame(() => {
          this.createControls();
          this.showActiveMedia();
        });
      }

      hide() {
        document.body.classList.remove('carami-product-modal-open');
        document.removeEventListener('keydown', this.handleKeydown);

        this.isZoomed = false;

        this.querySelectorAll('.carami-media-zoomed').forEach((image) => {
          image.classList.remove('carami-media-zoomed');
        });

        super.hide();
      }

      get mediaItems() {
        return Array.from(
          this.querySelectorAll(
            '.product-media-modal__content > [data-media-id]'
          )
        );
      }

      createControls() {
        const dialog = this.querySelector('.product-media-modal__dialog');

        if (!dialog || dialog.querySelector('.carami-modal-navigation')) {
          return;
        }

        const navigation = document.createElement('div');
        navigation.className = 'carami-modal-navigation';

        navigation.innerHTML = `
          <button
            type="button"
            class="carami-modal-arrow carami-modal-arrow--previous"
            aria-label="Immagine precedente"
          >
            &#8592;
          </button>

          <div class="carami-modal-counter" aria-live="polite">
            1 / 1
          </div>

          <button
            type="button"
            class="carami-modal-arrow carami-modal-arrow--next"
            aria-label="Immagine successiva"
          >
            &#8594;
          </button>
        `;

        dialog.appendChild(navigation);
      }

      showActiveMedia() {
        const items = this.mediaItems;

        if (!items.length) return;

        const openedMediaId = this.openedBy
          ? this.openedBy.getAttribute('data-media-id')
          : null;

        let activeIndex = items.findIndex(
          (item) => item.getAttribute('data-media-id') === openedMediaId
        );

        if (activeIndex < 0) activeIndex = 0;

        this.showMedia(activeIndex);
      }

      showMedia(index) {
        const items = this.mediaItems;

        if (!items.length) return;

        if (index < 0) index = items.length - 1;
        if (index >= items.length) index = 0;

        this.currentIndex = index;

        items.forEach((item, itemIndex) => {
          const isActive = itemIndex === index;

          item.classList.toggle('active', isActive);
          item.setAttribute('aria-hidden', isActive ? 'false' : 'true');

          const image = item.querySelector('img');

          if (image) {
            image.classList.toggle(
              'carami-media-zoomed',
              isActive && this.isZoomed
            );
          }
        });

        const activeMedia = items[index];
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        const content = this.querySelector('.product-media-modal__content');

        if (content) {
          content.scrollTop = 0;
          content.scrollLeft = 0;
        }

        this.updateControls();
      }

      updateControls() {
        const items = this.mediaItems;
        const counter = this.querySelector('.carami-modal-counter');
        const navigation = this.querySelector('.carami-modal-navigation');

        if (counter) {
          counter.textContent = `${this.currentIndex + 1} / ${items.length}`;
        }

        if (navigation) {
          navigation.hidden = items.length <= 1;
        }
      }

      showPreviousMedia() {
        this.showMedia(this.currentIndex - 1);
      }

      showNextMedia() {
        this.showMedia(this.currentIndex + 1);
      }

      handleKeydown(event) {
        if (!this.hasAttribute('open')) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showPreviousMedia();
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showNextMedia();
        }
      }

      handleClick(event) {
        const previousButton = event.target.closest(
          '.carami-modal-arrow--previous'
        );

        const nextButton = event.target.closest(
          '.carami-modal-arrow--next'
        );

        if (previousButton) {
          event.preventDefault();
          this.showPreviousMedia();
          return;
        }

        if (nextButton) {
          event.preventDefault();
          this.showNextMedia();
          return;
        }

        const image = event.target.closest(
          '.product-media-modal__content > .active img'
        );

        if (image) {
          this.isZoomed = !this.isZoomed;

          image.classList.toggle(
            'carami-media-zoomed',
            this.isZoomed
          );
        }
      }

      handleTouchStart(event) {
        this.touchStartX = event.changedTouches[0].screenX;
      }

      handleTouchEnd(event) {
        this.touchEndX = event.changedTouches[0].screenX;

        const distance = this.touchStartX - this.touchEndX;

        if (Math.abs(distance) < 50) return;

        if (distance > 0) {
          this.showNextMedia();
        } else {
          this.showPreviousMedia();
        }
      }
    }
  );
}